(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-winter-home"] && !Shopify.designMode) return;
  try {
    
function initWbStudio(root=document){
root.querySelectorAll('.wb-studio-products').forEach(section=>{
 const track=section.querySelector('.wb-studio-track');
 if(!track||track.dataset.ready)return;
 track.dataset.ready='true';
 const buttons=section.querySelectorAll('[data-wb-slide]');
 const update=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.wbSlide)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2);
 buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.wbSlide)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
 track.addEventListener('scroll',update,{passive:true});
 new ResizeObserver(update).observe(track);update();
});
}
initWbStudio();
document.addEventListener('shopify:section:load',e=>initWbStudio(e.target));

  } catch(e) { console.error(e); }
})();
})();
